<template>
    <el-dialog
        width="900px"
        :append-to-body="appendToBody"
        :modal-append-to-body="modalAppendToBody"
        v-if="myVisible"
        lock-scroll
        :visible.sync="myVisible"
        custom-class="similar-question-dialog"
        top="0"
        title="相似题推荐"
        :close-on-click-modal="false"
    >
        <div class="similar-body" v-loading="loading">
            <div class="similar-button">
                <button v-for="(item, index) in lists" :key="item.id" @click.prevent="active = index" :class="{ on: active === index }">{{ index + 1 }}</button>
            </div>
            <xes-question-single
                v-if="lists.length > 0"
                :index="active"
                :data="lists[active]"
                ref="testData"
                expand
                :key="lists[active].id"
                :activelist="activelist"
            >
                <template slot="bottomButtons" slot-scope="{ data, index, fade }">
                    <el-button v-if="matchActiveList(data.id)" class="btn" @click="delTopic(data, index, fade)">
                        <i class="iconfont icon-yichu"></i>移除
                    </el-button>
                    <el-button v-else class="btn" @click="addTopic(data, index, fade)"><i class="iconfont icon-tianjiashiti"></i>选题</el-button>
                    <slot name="bottomButtons" :data="data" :index="index" :fade="fade"></slot>
                </template>
                <template slot="topButtons" slot-scope="{ data, index, fade }">
                    <slot name="topButtons" :data="data" :index="index" :fade="fade"></slot>
                </template>
                <template slot="topInfo" slot-scope="{ data, index }">
                    <slot name="topInfo" :data="data" :index="index"></slot>
                </template>
                <template slot="bottomInfo" slot-scope="{ data, index }">
                    <slot name="bottomInfo" :data="data" :index="index"></slot>
                </template>
                <template slot="middleInfo" slot-scope="{ data, index }">
                    <slot name="middleInfo" :data="data" :index="index"></slot>
                </template>
            </xes-question-single>
            <div class="nodata" v-if="lists.length == 0">
                <div class="nodatapic"></div>
                <p>您的查询结果无内容</p>
            </div>
            <div class="bottom-box"></div>
        </div>
    </el-dialog>
</template>

<script>
import { httpRequest } from '../../../src/utils/ajax'
export default {
    name: 'xes-question-similar',
    props: {
        visible: {
            default: false
        },
        actions: {
            type: Object,
            required: true,
            default() {
                return {}
            }
        },
        question_id: {
            type: [String, Number],
            required: true
        },
        activelist: {
            type: Array,
            default: function() {
                return []
            }
        },
        appendToBody: {
            type: Boolean,
            default: true
        },
        modalAppendToBody: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            lists: [],
            active: 0,
            secret: '',
            loading: false
        }
    },
    created() {
        this.getSecret()
    },
    methods: {
        getSecret() {
            //获取secret
            const isActionNotPass = this.throwError('getSecret')
            if (!isActionNotPass) return
            this.loading = true
            var option = {
                method: 'POST',
                params: { uuid: this.getCookie('X-Request-Id') },
                action: this.actions.getSecret
            }
            httpRequest(option)
                .then(res => {
                    if (res.status == 100) {
                        this.secret = res.data
                        this.loading = false
                        if (this.myVisible) {
                            this.getSimilar()
                        }
                        this.ajaxSuccess({ ...res, flag: 'getSecret' })
                    } else {
                        this.statusError(res)
                    }
                })
                .catch(err => {
                    this.loading = false
                    this.ajaxError(err)
                })
        },
        getCookie(name) {
            if (document.cookie.length > 0) {
                var start = document.cookie.indexOf(name + '=')
                if (start != -1) {
                    start = start + name.length + 1
                    var end = document.cookie.indexOf(';', start)
                    if (end == -1) {
                        end = document.cookie.length
                    }
                    return unescape(document.cookie.substring(start, end))
                }
            }
            return ''
        },
        throwError(action) {
            // 若无相关地址，抛出错误
            if (!this.actions[action]) {
                throw new Error(`${action}地址为空！`)
            }
            return true
        },
        statusError(data) {
            console.log(data)
            this.$emit('status-error', data)
        },
        ajaxError(data) {
            console.log(data)
            this.$emit('ajax-error', data)
        },
        ajaxSuccess(data) {
            console.log(data)
            this.$emit('ajax-success', data)
        },
        getSimilar() {
            const isActionNotPass = this.throwError('getSimilarQues')
            if (!isActionNotPass) return
            this.loading = true
            var option = {
                method: 'POST',
                params: {
                    secret: this.secret,
                    ques_id: this.question_id
                },
                action: this.actions.getSimilarQues
            }
            httpRequest(option)
                .then(res => {
                    if (res.status == 100) {
                        this.lists = res.data
                        this.ajaxSuccess({ ...res, flag: 'getSimilarQues' })
                    } else {
                        this.statusError(res)
                    }
                    this.loading = false
                })
                .catch(err => {
                    this.ajaxError(err)
                    this.loading = false
                })
        },
        matchActiveList(id) {
            let state = false
            this.activelist.forEach(el => {
                if (el == id) {
                    state = true
                }
            })
            return state
        },
        addTopic(data, index, fade) {
            this.$emit('add-topic', data, index, mode => {
                if (data.id) {
                    if (!this.matchActiveList(data.id)) {
                        this.activelist.push(data.id)
                        fade(mode || 'leave-right')
                    }
                } else if (data.question_list) {
                    data.question_list.forEach(el => {
                        if (!this.matchActiveList(el.id)) {
                            this.activelist.push(el.id)
                            fade(mode || 'leave-right')
                        }
                    })
                }
            })
        },
        delTopic(data, index, fade) {
            this.$emit('del-topic', data, index, mode => {
                if (data.id) {
                    let index = this.activelist.indexOf(data.id)
                    if (index > -1) {
                        this.activelist.splice(index, 1)
                    }
                }
                fade(mode || 'enter-right')
            })
        }
    },
    watch: {
        myVisible(val) {
            if (val) {
                this.getSimilar()
            }
        }
    },
    computed: {
        myVisible: {
            get() {
                this.active = 0
                this.lists = []
                return this.visible
            },
            set(val) {
                if (val == this.visible) return
                this.$emit('update:visible', val)
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// packages/question-similar/src/index.vue